import React from 'react';
import './Intro.css';

const Intro = () => {
  return (
    <section className="intro">
      <div className="story">
        <p className="bio-text">
          My passion lies in building <strong>distributed systems</strong> and designing <strong>resilient infrastructure</strong>.
          I focus on architecting backend solutions that are rigorous, testable, and scalable. I actively experiment with <strong>AI agents</strong> to boost productivity and integrate them with workflows.
          I treat engineering as a means of leveraging software to <strong>innovate, inspire, and challenge the status quo</strong>.
        </p>

        <div className="poker-hand">
          {/* Card 1: Languages (Ace of Spades - Black) */}
          <div className="poker-card card-black">
            <div className="card-inner">
              <div className="card-front">
                <span className="card-corner top-left">A♠</span>
                <h3>Languages</h3>
                <span className="card-corner bottom-right">A♠</span>
              </div>
              <div className="card-back">
                <ul>
                  <li>Java</li>
                  <li>Python</li>
                  <li>C++</li>
                  <li>SQL</li>
                  <li>NoSQL</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Card 2: Backend (King of Hearts - Red) */}
          <div className="poker-card card-red">
            <div className="card-inner">
              <div className="card-front">
                <span className="card-corner top-left">K♥</span>
                <h3>Backend</h3>
                <span className="card-corner bottom-right">K♥</span>
              </div>
              <div className="card-back">
                <ul>
                  <li>Spring</li>
                  <li>gRPC</li>
                  <li>Microservices</li>
                  <li>Distributed Systems</li>
                  <li>Event-Driven</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Card 3: Cloud Infra (Queen of Clubs - Black) */}
          <div className="poker-card card-black">
            <div className="card-inner">
              <div className="card-front">
                <span className="card-corner top-left">Q♣</span>
                <h3>Cloud/ Infra</h3>
                <span className="card-corner bottom-right">Q♣</span>
              </div>
              <div className="card-back">
                <ul>
                  <li>AWS</li>
                  <li>Docker</li>
                  <li>Kubernetes</li>
                  <li>CI/CD</li>
                  <li>Linux</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Card 4: Reliability (Jack of Diamonds - Red) */}
          <div className="poker-card card-red">
            <div className="card-inner">
              <div className="card-front">
                <span className="card-corner top-left">J♦</span>
                <h3>Reliability</h3>
                <span className="card-corner bottom-right">J♦</span>
              </div>
              <div className="card-back">
                <ul>
                  <li>Monitoring</li>
                  <li>TDD</li>
                  <li>Load Testing</li>
                  <li>Security</li>
                  <li>Performance</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
